import * as React from 'react';

const FlatwareFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="flatware-fill_svg__eds-icon--flatware-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="flatware-fill_svg__eds-icon--flatware-fill_knife"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 2v20h3v-7h1V7c0-2.8-1.2-5-4-5z"
        />
        <path
            id="flatware-fill_svg__eds-icon--flatware-fill_fork"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 6H9V2H8v4H7V2H6v8h2v4H7v8h3v-8H9v-4h2V2h-1z"
        />
    </svg>
);

FlatwareFillSvg.displayName = 'FlatwareFillSvg';
export default FlatwareFillSvg;
